export default "data:application/vnd.ms-fontobject;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZm9udGF3ZXNvbWUtd2ViZm9udC5lb3QiOw=="